import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getPaymentMethodType(payload) {
  const criteria = { filters: ['id', 'key'], firstResult: 0, maxResults: 51 };

  const url = `/PaymentMethodType/restrictions?criteria=${encodeURI(criteria)}`;
  const response = await defaultFetch(url, payload, 'POST');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response;
}

export function usePaymentMethodType(payload) {
  const FIVE_MINUTES_IN_MS = 1000 * 60 * 5;
  return useQuery({
    queryKey: ['payment-method-type'],
    staleTime: FIVE_MINUTES_IN_MS,
    queryFn: async () => getPaymentMethodType(payload)
  });
}
